/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Labels import colors
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { Green, SpbSky1 } from './palette';

export const labelsImportValidationStatusBorder = SpbSky1;
export const labelsImportValidationStatusProgressBarWaiting = SpbSky1;
export const labelsImportValidationStatusProgressBarSuccess = Green;
